/* global Foundation */

// @codekit-prepend quiet "../node_modules/foundation-sites/dist/js/plugins/foundation.core.min.js";
// @codekit-prepend quiet "../node_modules/foundation-sites/dist/js/plugins/foundation.util.mediaQuery.min.js";

jQuery(document).foundation();

// !codekit-prepend quiet "../bower_components/matchHeight/dist/jquery.matchHeight-min.js";
// !codekit-prepend quiet "../bower_components/fancybox/dist/jquery.fancybox.min.js";
// !codekit-prepend quiet "../bower_components/slick-carousel/slick/slick.min.js";
// !codekit-prepend quiet "../node_modules/what-input/dist/what-input.js";


(function($){
	
	var menu_breakpoint = 'medium';
	
	function myScrollTo( $target, $trigger ){
		if( $target.length ) {
			var offTop = $target.position().top;
			
			if( $trigger.attr('data-ignore-header') === undefined ){ 
				offTop -= $('#site-header').outerHeight();
				offTop -= 100;
			}
			
			var animationTime = Math.abs( offTop - $(window).scrollTop() ) * 0.6;
			
			if( $trigger.attr('data-speed') ) animationTime = parseFloat($trigger.attr('data-speed'));
			
			$('html, body').stop().animate( {scrollTop: offTop}, animationTime );
		}
	}
	
	function myTabsInit(){
			
		function fixTabs($wrap){
			$('.tabs-wrap', $wrap).each(function(){
				$(this).css({minHeight: ''});
				var maxH = 0;
				$(this).children().each(function(){
					$(this).show();
					var h = $(this).outerHeight(true);
					$(this).css({display: ''});
					if( h > maxH ) maxH = h;
				});
				$(this).css({minHeight: maxH});
			});
		}
		
		var tabstimer;
		
		function showTab($wrap, target, animateHeight){
			
			var time = 400;
			if( $wrap.attr('data-time') ) time = $wrap.attr('data-time');
			
			var $container = $( $wrap.attr('data-target') );
			
			var $target = $container.find( target );
			
			if( $target.hasClass('is-active') ) return;
			
			$wrap.find('[data-tabs-nav]').removeClass('is-active');
			$wrap.find('[data-tabs-nav][href="'+target+'"]').addClass('is-active');
			
			if(animateHeight && !Foundation.MediaQuery.atLeast(animateHeight) ) $container.css({height: ''});
			
			var currentContainerHeight = $container.outerHeight();
			
			$container.find('.tab-content.is-active').not( $target ).removeClass('is-active').removeAttr('style').css({display: 'block', position: 'absolute'}).stop().animate({opacity: 0}, time, function(){
				$(this).removeAttr('style');
			});
			
			$target.addClass('is-active').removeAttr('style').css({opacity:0});
			
			var newContainerHeight = $container.outerHeight();
			
			if( animateHeight && !Foundation.MediaQuery.atLeast(animateHeight) ){
				$container.css({height: currentContainerHeight});
				$container.stop().animate({height: newContainerHeight}, time);
			}
			
			$target.stop().animate({opacity: 1}, time, function(){
				$(this).removeAttr('style');
				if(animateHeight && !Foundation.MediaQuery.atLeast(animateHeight)) $container.css({height: ''});
			});
			
			$(window).trigger('scroll');
			
			clearTimeout(tabstimer);

			
		}
		
		$('[data-tabs]').each(function(){
			
			
			var $wrap = $(this);
			var defaultTarget = $wrap.attr('data-default');
			var $navItems = $wrap.find('[data-tabs-nav]');
			var animateHeight = ($wrap.attr('data-animate-height') );
			if(!animateHeight && animateHeight !== undefined ) animateHeight = 'never';
			
			$(document).on('touchstart', function(e){
				if( $wrap.find(e.srcElement).length ) return;
				if( defaultTarget ) showTab($wrap, defaultTarget, animateHeight);
			});
			
			$navItems.click(function(e){
				e.preventDefault();
				e.stopPropagation();
			});
			
			$navItems.hover(function(){
				
				var target = $(this).attr('href');
				showTab($wrap, target, animateHeight);
				
			}, function(e){
				if( $navItems.find(e.toElement).length && $('[data-tabs-nav]', e.toElement).length <= 1 ) return
				
				if( defaultTarget ){
					tabstimer = setTimeout(function(){ showTab($wrap, defaultTarget, animateHeight); }, 100);
				}
			});
			
			if(!animateHeight || (animateHeight && Foundation.MediaQuery.atLeast(animateHeight)) ) fixTabs($wrap);
			else $('.tabs-wrap', $wrap).css({minHeight: ''});
			
			$(window).resize(function(){
				if(!animateHeight || (animateHeight && Foundation.MediaQuery.atLeast(animateHeight)) ) fixTabs($wrap);
				else $('.tabs-wrap', $wrap).css({minHeight: ''});
			});
			
		});
		
	}
	
	function fixedNav(){
		
		if( ! $('body').hasClass('fixed-nav') ) return;
		
		var scrolltop = $(window).scrollTop();
		var hTop = 0;
		
// 		if( Foundation.MediaQuery.atLeast('medium') ){		
			if(scrolltop > hTop && !$('#site-header').hasClass('sticky') ){
				$('#site-header').addClass('sticky');
			}
			if(scrolltop <= hTop && $('#site-header').hasClass('sticky') ){
				$('#site-header').removeClass('sticky');
			}
/*
		}
		else {
			$('#site-header').removeClass('sticky');
		}
*/
			
	}

	function loadEvents(){
		
		$('a[href="#"]').click(function(e){
			e.preventDefault();
		});
		
		
		$('a[href^="#"]:not([data-tabs-nav])').click(function(e){

			var $target = $( $(this).attr('href') );

			if( $target.length ) e.preventDefault();

			myScrollTo($target, $(this) );
		});
		
		$('a[data-scroll-down]').click(function(e){
			
			var $target = $( $(this).attr('href') );
			if( !$target.length ) $target = $(this).closest('section').next('section');
			
			if( $target.length ) e.preventDefault();
			
			myScrollTo($target, $(this) );
			
		});

	}
	
	function menuEvents(){
		
		$('#site-header .menu li.menu-item-has-children').append('<div class="arrow">');
	
		$('#site-header .menu li.menu-item-has-children .arrow').click(function(){
			$(this).siblings('.sub-menu').stop().slideToggle(200);
		});
		
		$('#site-header .menu li.menu-item-has-children > a[href="#"]').click(function(){
			if( ! Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$(this).siblings('.sub-menu').stop().slideToggle(200);
			}
		});
		
		$('#site-header .menu .menu a:not([href="#"])').click(function(){
			if( ! Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$('#site-header .menu-wrap, #hamburger').removeClass('active');
			}
		});
		
		$('#hamburger').click(function(){
			if( ! Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$('#site-header .menu-wrap').toggleClass('active');
				$(this).toggleClass('active');
			}
		});
		
		$('#site-header .menu li.menu-item-has-children').hover(function(){
			if( Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$(this).children('.sub-menu').stop().fadeIn(200);
			}
		}, function(){
			if( Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$(this).children('.sub-menu').stop().fadeOut(200);
			}
		});
		
		$(window).on('changed.zf.mediaquery', function() {
		  if(Foundation.MediaQuery.atLeast(menu_breakpoint)){
				$('#site-header .menu .sub-menu').hide();
			}
		});
	}

	
	
	$(document).ready(function(){
		fixedNav();
		loadEvents();
		menuEvents();
		myTabsInit();
	});
	
	
	$(window).scroll(function(){
		requestAnimationFrame(function(){
			fixedNav();
		});
	});

	
	
})(jQuery);
